<template>
  <div class="case-library-banner" :class="'case-library-banner--' + theme">
    <div class="case-library-banner-copy">
      <span>城市治理 · 教学案例</span>
      <strong>{{ platform === 'policy' ? '政策实训' : '网格实训' }}</strong>
      <span>{{ category || '综合治理' }}</span>
    </div>
    <svg class="case-library-banner-art" viewBox="0 0 240 128" aria-hidden="true" focusable="false">
      <!-- A shared isometric city illustration for both case libraries. -->
      <path d="M23 95 132 42l91 40-108 47z" fill="#8cb0b0" opacity=".13"/>
      <path d="M21 91 130 38l91 40-109 48z" fill="#d4e8cf"/>
      <path d="M21 91 112 126v-5L21 87z" fill="#b7d6bc"/>
      <path d="m112 121 109-48v5l-109 48z" fill="#a5cdb1"/>
      <path d="m34 91 96-46 78 34-96 42z" fill="#a7d6aa"/>
      <path d="m32 96 8 3 100-47-8-4zM187 72l8 3-96 43-8-3z" fill="#f2f5e3"/>
      <path d="m44 100 7 3 96-45-7-3z" fill="#b1d6d2"/>
      <path d="m42 100 7 3-2 1-7-3z" fill="#f0cc83"/>
      <path d="m170 88 7 3-3 2-7-3z" fill="#f3a982"/>
      <!-- Buildings have light roofs and two shaded façades. -->
      <path d="m51 57 25-12 23 10-25 12z" fill="#f7ffff"/>
      <path d="m51 57 23 10v32L51 89z" fill="#cce6e9"/>
      <path d="m74 67 25-12v32L74 99z" fill="#98c8d2"/>
      <path d="m57 64 4 2v5l-4-2zm9 4 4 2v5l-4-2zm-9 6 4 2v5l-4-2zm9 4 4 2v5l-4-2z" fill="#f6ffff"/>
      <path d="m79 69 4-2v5l-4 2zm8-4 4-2v5l-4 2zm-8 14 4-2v5l-4 2zm8-4 4-2v5l-4 2z" fill="#eaf9f8"/>
      <path d="m91 36 31-15 34 15-31 15z" fill="#faffff"/>
      <path d="m91 36 34 15v47L91 83z" fill="#d1ebed"/>
      <path d="m125 51 31-15v47l-31 15z" fill="#a1ced5"/>
      <path d="m98 44 5 2v6l-5-2zm10 5 5 2v6l-5-2zm10 4 4 2v6l-4-2zm-20 3 5 2v6l-5-2zm10 5 5 2v6l-5-2zm10 4 4 2v6l-4-2zm-20 3 5 2v6l-5-2zm10 5 5 2v6l-5-2zm10 4 4 2v6l-4-2z" fill="#f8ffff"/>
      <path d="m131 53 5-2v6l-5 2zm10-5 5-2v6l-5 2zm-10 17 5-2v6l-5 2zm10-5 5-2v6l-5 2zm-10 17 5-2v6l-5 2zm10-5 5-2v6l-5 2z" fill="#effbfa"/>
      <path d="m152 64 22-10 24 10-22 11z" fill="#faffff"/>
      <path d="m152 64 24 11v26l-24-10z" fill="#d6edef"/>
      <path d="m176 75 22-11v27l-22 10z" fill="#a6d0d5"/>
      <path d="m157 70 4 2v5l-4-2zm9 4 4 2v5l-4-2zm-9 6 4 2v5l-4-2zm9 4 4 2v5l-4-2z" fill="#fbffff"/>
      <path d="m181 77 4-2v5l-4 2zm8-4 4-2v5l-4 2zm-8 14 4-2v5l-4 2zm8-4 4-2v5l-4 2z" fill="#effbfa"/>
      <!-- Small trees and public-space details. -->
      <g stroke="#7ea88a" stroke-width="1.4" stroke-linecap="round">
        <path d="M41 86v9M85 100v10M164 100v10M205 79v9"/>
      </g>
      <g fill="#77bd85"><circle cx="41" cy="84" r="4"/><circle cx="85" cy="98" r="4.5"/><circle cx="164" cy="98" r="4"/><circle cx="205" cy="77" r="4"/></g>
      <g fill="#9cd6a0"><circle cx="40" cy="82" r="2"/><circle cx="84" cy="96" r="2.2"/><circle cx="163" cy="96" r="2"/><circle cx="204" cy="75" r="2"/></g>
      <path d="m115 111 5-2 5 2-5 2z" fill="#f3c56b"/>
    </svg>
  </div>
</template>

<script>
const themes = ['blue', 'green', 'apricot', 'lavender', 'mint', 'rose']

export default {
  name: 'CaseLibraryBanner',
  props: {
    platform: { type: String, default: 'network' },
    category: { type: String, default: '' },
    themeIndex: { type: Number, default: 0 }
  },
  computed: { theme () { return themes[Math.abs(this.themeIndex) % themes.length] } }
}
</script>
